<label>{{ label }}</label>
<select class="form-control" [(ngModel)]="value" (change)="onChange($event)">
  <option [value]="0">All</option>
  <option *ngFor="let pt of settingsSvc.productDepartments" [value]="pt.id">
    {{ pt.text }}
  </option>
</select>
